import React from 'react';
import Cookie from '~/js/modules/Cookie';
const { Component } = React;

const internals = {};

internals.fetchRequest = (endpointURL, requestBody) => {
  const data = {
    headers: {
      'content-type': 'application/json',
    },
    method: 'POST',
    body: JSON.stringify(requestBody)
  };

  return fetch(endpointURL, data);
};
internals.setSubscribedCookie = () => {
  document.cookie = 'ALREADY_SUBSCRIBED=true; Path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT;';
};

export default class SubscribeAndSave extends Component {
  constructor(props) {

    super(props);

    //const popupTrigger = Math.floor(Math.random() * 3) > 1;

    this.state = {
      closed: false,
      popup: false,
      notSubscribed: false,
      thankYou: false,
      isChecked: false,
      formData: {
        firstName: '',
        email: '',
        country: 'US',
        subscribe: false,
        emailInvalid: false,
      },
      formError: {
        firstName: false,
        email: false,
        country: false,
        subscribe: false,
      },
      submitAttempts: 1,
      errorMessage: '',
      isPostingInformation: false,
    };
  }

  componentDidMount() {
    document.addEventListener("keydown", this._escFunction, false);
    this._counterVisitedTimes();
    const newNotSubscribed =
      !Cookie.has("ALREADY_SUBSCRIBED") && Cookie.get("VISITED_TIMES") === "3";

    this.setState({
      notSubscribed: newNotSubscribed,
    });

    this._protectedPages();

    // Set focus on first input.
    const $nameInput = document.querySelector('#subSaveName');

    if ($nameInput) {
      $nameInput.focus();
    }
  }

  _protectedPages = () => {
    $('html').addClass(this.state.notSubscribed ? 'html-no-scroll' : '');
    const hasSubscription = Cookie.has('ALREADY_SUBSCRIBED');
    const pages = ['/deals/', '/top-10-reasons/', '/resorts/', '/disclaimers/'];
    const protectedUrls = pages.map(page => this.props.requestURI.includes(page));
    const isProtected = protectedUrls.some(url => url);

    if (isProtected || hasSubscription) {
      this.setState({ popup: false }, () => $('html').removeClass('html-no-scroll'));
    }
  }

  _counterVisitedTimes = () => {
    if (!Cookie.has("VISITED_TIMES")) {
      document.cookie =
        "VISITED_TIMES=1; Path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT;";
    } else {
      if (!Cookie.has("ALREADY_SUBSCRIBED")) {
        var counter = Cookie.get("VISITED_TIMES");
        counter++;
        document.cookie = `VISITED_TIMES=${counter}; Path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT;`;
      }
    }
  };

  _closeModal = () => {
    internals.setSubscribedCookie();
    $("#modal-bg").removeClass("cover-modal");
    $("html").removeClass("html-no-scroll");

      this.setState({
        closed: true,
        isPostingInformation: false,
      });
  }

  _submitForm = async(event) => {
    event.preventDefault();
    const { fetchRequest } = internals;
    const { formData, submitAttempts } = this.state;
    const errors = Object.keys(formData).filter((inputName) => inputName !== 'email' ).reduce((acc, current) => {
      const error = formData[current].length <= 0;

      return { ...acc, [current]: error };
    }, {});

    this._displayLoader();

    /**
     * GCV API request
     */
    const gcvResponse = await fetchRequest('/gcv/email/', { email: formData.email });
    const gcvResponseData = await gcvResponse.json();
    const { STATUSNUMBER } = gcvResponseData.data.gcvResponse;

    errors.email = (STATUSNUMBER !== 200);
    formData.emailInvalid = (STATUSNUMBER !== 200);

    const formHasErrors = Object.keys(errors).filter((inputName) => inputName !== 'email').some((inputName) => errors[inputName]);

    if (formHasErrors) {
      const errorMessage = 'Action required.';

      this._triggerError(errorMessage, errors);
      this._displayLoader(false);

      return 0;
    }

    // Evaluate if email is invalid but ommit if the user is re-attempting with an invalid email.
    if (formData.emailInvalid && submitAttempts <= 1) {
      const errorMessage = 'Email not valid.';

      this._triggerError(errorMessage, errors);
      this._displayLoader(false);
      this.setState({ submitAttempts: submitAttempts + 1 });

      return 0;
    }

    /**
     * Posting information
     */
    const subscriptionResponse = await fetchRequest('/subscription/submit/', formData);
    const subscriptionResponseData = await subscriptionResponse.json();

    if (subscriptionResponseData.status === 'success') {
      this._renderThankYou();
    } else {
      this._triggerError('Oops, there was an error while submitting your information. Please try again.', errors);
    }

    this._displayLoader(false);

    return 0;
  }

  _displayLoader = (isPostingInformation = true) => this.setState({ isPostingInformation });

  _triggerError = (errorMessage, errors) => this.setState({ errorMessage, formError: errors });

  _formControlHandler = (event) => {
    const { name, value } = event.target;
    const { formData } = this.state;
    const newFormData = { ...formData, [name]: (name === 'subscribe') ? event.target.checked : value };

    this.setState({ formData: newFormData });
  }

  _onKeyUpAccessibilityHandler = (e) => {
    const { keyCode } = e.nativeEvent;
    const { _closeModal } = this;

    if (keyCode === 27) {
      _closeModal();
    }
  }

  _renderThankYou = () => {
    this.setState({
      popup: false,
      thankYou: true
    });
    internals.setSubscribedCookie();
  }

  render() {
    const { _formControlHandler, _submitForm, _closeModal, _onKeyUpAccessibilityHandler } = this;
    const {
      popup,
      notSubscribed,
      closed,
      thankYou,
      isPostingInformation,
      errorMessage,
      formData: { firstName, country, email, subscribe },
      formError: {
        firstName: firstNameHasError,
        country: countryHasError,
        email: emailHasError,
      },
    } = this.state;
    //const notSubscribed = !Cookie.has('ALREADY_SUBSCRIBED') && popup;

    return (
      <div id="modal-bg" className={notSubscribed ? 'cover-modal' : ''} onClick={ _closeModal }>
        { notSubscribed &&
          <div className={'subSave' + (closed ? ' closed' : '')} onKeyUp={ _onKeyUpAccessibilityHandler } onClick={ (e) => e.stopPropagation() }>
            <h3 className="subTitle">GET THE LATEST DEALS</h3>
            <p>Newsletters, Deals and more, directly into your inbox</p>
            <label id="action-required" className={`empty-field-error ${(errorMessage.length ? '' : 'hide')}`}>{ errorMessage }</label>
            <form onSubmit={ _submitForm } id="subSaveForm" action="/subscription/submit/" method="post" encType="multipart/form-data">
              <div className="group">
                <label htmlFor="name">Name:</label>
                <input className={`form-control ${ (firstNameHasError) ? 'has-error' : '' }`} type="text" name="firstName" id="subSaveName" required pattern="(^$)|^[a-zA-Z\u00C0-\u02AB'´`\-\s]+\.?\s?([a-zA-Z\u00C0-\u02AB'´`\-\s]+\.?\s?)+$" title="Numbers are not allowed, special characters are not allowed except hyphens" onChange={ _formControlHandler } value={ firstName } />
              </div>
              <div className="group">
                <label htmlFor="email">Email:</label>
                <input className={`form-control ${ (emailHasError) ? 'has-error' : '' }`} type="email" name="email" id="subSaveEmail" required onChange={ _formControlHandler } value={ email }/>
              </div>
              <div className="group">
                <label htmlFor="country">Country: </label>
                <div className="control-wrapper custom-ddl">
                  <select className={`form-control ${ (countryHasError) ? 'has-error' : '' }`} onChange={ _formControlHandler } name="country" id="subSaveCountry" value={ country }>
                    <option value="US">United States</option>
                    <option value="CA">Canada</option>
                    <option value="XX">Other</option>
                  </select>
                </div>
              </div>
              <div className="terms-wrapper">
                <div className="row terms-box">
                  <div className="xs-1 xl-offset-1 terms-btn checkbox-btn-wrapper pr">
                    <input onChange={ _formControlHandler } type="checkbox" id="subscribe" name="subscribe" checked={ subscribe } required/>
                    <label htmlFor="subscribe" className="checkbox-btn" />
                  </div>
                  <label htmlFor="subscribe" className="form-label xs-10 terms checkbox-text">
                  I want to receive promotional emails about Beaches Resorts from Unique Travel Corp., the Worldwide Representative of Beaches Resorts, c/o P.O. Box SS-19020, Nassau, Bahamas. You can contact us at <a href="mailto:info@sandals.com">info@beaches.com</a>. You may unsubscribe at any time.
                  </label>
                </div>
              </div>
              <button className={`subButton ${isPostingInformation && 'disabled'}`} type="submit" disabled={isPostingInformation}>
                { isPostingInformation ? 'PROCESSING INFORMATION' : 'Sign Up' }
              </button>
            </form>
            <button className="close-button pa" onClick={ _closeModal }><i className="icon-close" /></button>
          </div>
        }
        { thankYou &&
          <div className={'subSave thankYou' + (closed ? ' closed' : '')}>
            <button className="close-button pa" onClick={ _closeModal }><i className="icon-close" /></button>
            <h3 className="subTitle thankYou">THANK YOU!</h3>
            <p className="thankYouCopy">You will receive a confirmation email shortly. Please make sure you click on the “VERIFY” button to guarantee delivery.</p>
            <button className="subButton thankYou" onClick={ _closeModal }>CLOSE</button>
          </div>
        }
      </div>
    );
  }
}
